export const getBaseUrl = () :string => {
  let url = window.location.origin;
  if (!url.endsWith('/')) url += '/';
  return url;
};
